import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PullOutInventoryFormStyle from './css/PullOutInventoryFormStyle'
import { formatNumber } from '../../../utilities/utilities'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'

function PullOutInventoryForm (props) {
  const { invoiceParticular, addPulledOutItemHistory, updateItemInventory, buttonClicked } = props
  const [pullOutQuantity, setPullOutQuantity] = useState({})
  const [accumulatedUnitQuantity, setAccumulatedUnitQuantity] = useState({})
  const [totalUnitsPulledOutQuantity, setTotalUnitsPulledOutQuantity] = useState(0.00)
  const [newPulledOutUnitInventory, setNewPulledOutUnitInventory] = useState(0.00)
  const [activeInput, setActiveInput] = useState('')
  const [errorMessage, setErrorMessage] = useState(null)
  const [enableApplyButton, setEnableApplyButton] = useState(false)
  const currentItem = props.ci // an updated currentItem (state). ci is not a state

  const currentItemUnit = currentItem.units
    .find(item => (item.description === invoiceParticular.unit))

  // Exclude the current item unit asking for pull-out on first filter
  const currentItemContainerUnit = currentItem.units
    .filter(item => ((item.description !== invoiceParticular.unit) && item.inventory > 0))

  const onClick = async (e) => {
    if (e.target.id === 'btn-apply') {
      const units = []

      for (let itemUnit in pullOutQuantity) {
        // Add it only when item unit name isn't null and it's quantity is greater than 0
        // Item pulled out
        if (itemUnit && (parseFloat(pullOutQuantity[itemUnit]) > 0))
          units.push({
            unit: itemUnit,
            quantity: pullOutQuantity[itemUnit],
            mode: -1
          })
      }

      // Item pushed in
      units.push({
        unit: currentItemUnit.description,
        quantity: totalUnitsPulledOutQuantity,
        mode: 1
      })

      const newPulledOutItemHistory = {
        item_id: currentItem._id,
        units
      }

      // Do the actual pulling and pushing on the database
      // assuming rightnow nothing goes wrong 
      for (let item of units) {
        //item.expiration_date = (item.mode === 1) ? invoiceParticular.expiration_date : ''
        item.expiration_date = invoiceParticular.expiration_date
        const ip = { item_id: currentItem._id, ...item }
        await updateItemInventory(item.mode, ip)
      }

      addPulledOutItemHistory(newPulledOutItemHistory)

      buttonClicked('Apply')

    } //else buttonClicked('Cancel')

    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onChange = (e) => {
    const itemUnit = currentItemContainerUnit.find(item => item.description === e.target.name)
    setActiveInput(e.target.name)

    if (parseFloat(e.target.value) <= parseFloat(itemUnit.inventory)) {
      e.target.value = (itemUnit.fractional) ? parseFloat(e.target.value) : parseInt(e.target.value)
      setPullOutQuantity({ ...pullOutQuantity, [e.target.name]: (e.target.value) ? e.target.value : '' })

    } else {
      if (!isNaN(parseFloat(e.target.value))) {
        ReactDOM.render (
          <ModalWindow
            id='mw-child'
            height='30'
            width='35'
            header="Quantity Error"
            footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Quantity cannot be over the available inventory of the current selected unit.</div>
                <br />
                <div>Please input proper quantity total.</div>
              </div>
              <div className='button-container'>
                <button
                  onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent')) }}
                  className='pospro-action-btn top-anchor'>
                  Ok
                </button>
              </div>
            </div>
          </ModalWindow>,
          document.getElementById('mw-parent')
        )
      }
      setPullOutQuantity({ ...pullOutQuantity, [e.target.name]: '' })
    }
  }

  // Will evaluate/compute data in per units pulled-out
  useEffect(() => {
    if (!activeInput) return

    const itemUnit = currentItemContainerUnit.find(item => item.description === activeInput)

    // If current item unit is a child of the unit
    if (itemUnit.description.search(currentItemUnit.unit_name) > 0) {
      // Get only element with numbers and exclude which are not
      const itemUnitDescriptionSplitted = itemUnit.description.split('(').filter(item => parseFloat(item))

      if (itemUnitDescriptionSplitted.length > 0) {
        let i = 0
        let found = false
        let totalAccumulatedUnitQuantity = 1

        while (!found) {
          totalAccumulatedUnitQuantity *= parseFloat(itemUnitDescriptionSplitted[i])
          found = (itemUnitDescriptionSplitted[i++].search(currentItemUnit.unit_name) > 0)
        }

        setAccumulatedUnitQuantity({
          ...accumulatedUnitQuantity,
          [activeInput]: totalAccumulatedUnitQuantity * pullOutQuantity[activeInput]
        })
      }
    } else if (currentItemUnit.description.search(itemUnit.unit_name) > 0) {
      // Split currentItemUnit
      // Get only element with numbers and exclude which are not
      const currentItemUnitSplitted = currentItemUnit.description.split('(').filter(item => parseFloat(item))

      if (currentItemUnitSplitted.length > 0) {
        let i = 0
        let found = false
        let totalAccumulatedUnitQuantity = 1

        while (!found && (i < currentItemUnitSplitted.length)) {
          totalAccumulatedUnitQuantity *= parseFloat(currentItemUnitSplitted[i])
          found = (currentItemUnitSplitted[i++].search(itemUnit.unit_name) > 0)
        }
        setAccumulatedUnitQuantity({
          ...accumulatedUnitQuantity,
          [activeInput]: pullOutQuantity[activeInput] / totalAccumulatedUnitQuantity
        })
      }
    } else {
      if (itemUnit.contents === currentItemUnit.contents) {
        const totalAccumulatedUnitQuantity = parseInt(parseFloat(itemUnit.contents_quantity * pullOutQuantity[activeInput]) / currentItemUnit.contents_quantity)
        setAccumulatedUnitQuantity({
          ...accumulatedUnitQuantity,
          [activeInput]: totalAccumulatedUnitQuantity
        })
      }
    }
    // The comment below is a hack to remove warning about useEffect dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pullOutQuantity])

  // Will evaluate and compute data in the summary portion
  useEffect(() => {
    let pulledOutQuantityTotal = 0

    for (let unitName in accumulatedUnitQuantity) {
      pulledOutQuantityTotal += (
        !isNaN(parseFloat(accumulatedUnitQuantity[unitName]))
        ? parseFloat(accumulatedUnitQuantity[unitName])
        : 0.00
      )
    }

    setTotalUnitsPulledOutQuantity(parseFloat(pulledOutQuantityTotal))
    setNewPulledOutUnitInventory((pulledOutQuantityTotal + currentItemUnit.inventory) - invoiceParticular.quantity)

    // The comment below is a hack to remove warning about useEffect dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accumulatedUnitQuantity])

  // Sets Apply buttons enable/disable base on the data on the summary
  // wether it holds right or valid data
  useEffect(() => {
    setEnableApplyButton(
      (totalUnitsPulledOutQuantity - totalUnitsPulledOutQuantity === 0) &&
      (totalUnitsPulledOutQuantity > 0) &&
      (newPulledOutUnitInventory >= 0)
    )

    // // Total pulled quantity is a fraction number
    if ((totalUnitsPulledOutQuantity - parseInt(totalUnitsPulledOutQuantity)) !== 0)
      setErrorMessage('Fractional number result is not valid.')
    else setErrorMessage(null)

  }, [totalUnitsPulledOutQuantity, newPulledOutUnitInventory])

  return (
    <React.Fragment>
      <div id='pull-out-inventory-form'>
        <p id='out-of-stock-message'><i>{invoiceParticular.unit}</i> is out-of-stock</p>
        <div id='current-item-stock-status-container'>
          <h6>{invoiceParticular.unit + "'s"} needed: {formatNumber(invoiceParticular.quantity.toFixed(2))}</h6>
          <h6>Available stock: <span style={{color: 'red'}}>{formatNumber(currentItemUnit.inventory.toFixed(2))}</span></h6>
        </div>
        <p id='pull-out-message'>
          ...but you can <b>pull-out</b> <i>{invoiceParticular.unit + "'s"}</i> from
          { (currentItemContainerUnit.length > 1) ? ' these available units.' : ' this available unit.' }
        </p>
        <table id='table-item-units-container'>
          <thead>
            <tr>
              <th>Item Unit</th>
              <th style={{textAlign: 'center'}}>Inventory</th>
              <th style={{textAlign: 'center'}}>Quantity</th>
              <th style={{textAlign: 'right'}}>Accumulated {invoiceParticular.unit}</th>
            </tr>
          </thead>
          <tbody>
          {
            currentItemContainerUnit.map((item, index) => (
              <tr key={index}>
                <td>{item.description}</td>
                <td style={{textAlign: 'center'}}>{formatNumber(item.inventory.toFixed(2))}</td>
                <td style={{textAlign: 'center'}}>
                  <input
                    className='pull-out-quantity top-anchor'
                    id={index+'pull-out-quantity'}
                    type='number'
                    min='0'
                    name={item.description}
                    value={pullOutQuantity[item.description] || ''}
                    onChange={onChange}
                  />
                </td>
                <td style={{textAlign: 'right'}}>{accumulatedUnitQuantity[item.description] ? formatNumber(accumulatedUnitQuantity[item.description].toFixed(2)) : '0.00'}</td>
              </tr>
            ))
          }
          </tbody>
        </table>
        <br />
        <table id='table-pulled-out-summary'>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}} colSpan='2'>Summary</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total <i>{invoiceParticular.unit}</i> needed</td>
              <td style={{textAlign: 'right'}}>{formatNumber(invoiceParticular.quantity.toFixed(2))}</td>
            </tr>
            <tr>
              <td>Total <i>{invoiceParticular.unit}</i> pulled-out</td>
              <td style={{textAlign: 'right', color: errorMessage ? 'red' : 'black'}}>{!isNaN(totalUnitsPulledOutQuantity) ? formatNumber(totalUnitsPulledOutQuantity) : '0.00' }</td>
            </tr>
            <tr>
              <td>Current <i>{invoiceParticular.unit+"'s"}</i> inventory</td>
              <td style={{textAlign: 'right'}}>{formatNumber(currentItemUnit.inventory.toFixed(2))}</td>
            </tr>
            <tr>
              <td colSpan='2'>
                <hr />
              </td>
            </tr>
            <tr>
              <td>New <i>{invoiceParticular.unit+"'s"}</i> inventory</td>
              <td style={{textAlign: 'right'}}>{!isNaN(newPulledOutUnitInventory) ? formatNumber(newPulledOutUnitInventory) : '0.00'}</td>
            </tr>
          </tbody>
        </table>
        <div id='actions-buttons-group'>
          <div id='notification' style={{display: errorMessage ? 'block' : 'none'}}>Error: <span style={{color: 'green'}}>{errorMessage}</span></div>
          <button
            id='btn-apply'
            className={!enableApplyButton ? 'pospro-action-btn disabled-button' : 'pospro-action-btn'}
            disabled={!enableApplyButton}
            onClick={onClick}>
            Apply
          </button>
          <button id='btn-cancel' className='pospro-action-btn' onClick={onClick}>Cancel</button>
        </div>
      </div>
      <PullOutInventoryFormStyle />
    </React.Fragment>
  )
}

export default React.memo(PullOutInventoryForm)
